module.exports = __webpack_public_path__ + "logo-welcome.svg?4b84e817614fc9f7f0d8817755a49dc0";